import React from 'react';
import EventDetails from 'components/events/eventDetails';
import Messages from 'components/events/messages';

export default React.createClass({
    getHeaderLine() {
        const types = [];
        const event = this.props.event;

        event.leads.forEach((lead) => {
            if (types.indexOf(lead.vendor_type) < 0) {
                types.push(lead.vendor_type);
            }
        });

        if (types.length === 1) {
            if (types[0] === 'Venue') {
                return <h4>Venue Messages</h4>;
            } else if (types[0] === 'Caterer') {
                return <h4>Caterer Messages</h4>;
            }
        }

        return <h4>Vendor Messages</h4>;
    },

    render() {
        const event = this.props.event;

        return (
            <div className="event-details">
                <div className="container">
                    <EventDetails event={event} />

                    <div className="event-lead">
                        {this.getHeaderLine()}

                        {event.leads.length === 0 && <div className="empty-message">Venues and vendors that can accommodate your event will respond here.</div>}
                        {event.leads.length > 0 && <Messages event={this.props.event} leadId={this.props.params.leadId} />}
                    </div>
                </div>
            </div>
        );
    },
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/views/events/eventLead.jsx